export const copyToClipBoard = (value) => (value ? navigator.clipboard.writeText(value) : null);
